import type { SubmitEventHandler } from "react";

import { cn } from "@homeinstead/ui";
import { forwardRef } from "react";

export type LeadFormFormProps = {
  action: (formData: FormData) => void;
  className?: string;
  children: React.ReactNode;
  /**
   * Runs on the native `submit` event, before React's action dispatch.
   * Calling `event.preventDefault()` here skips `action` entirely.
   */
  onSubmit?: SubmitEventHandler<HTMLFormElement>;
};

export const LeadFormForm = forwardRef<HTMLFormElement, LeadFormFormProps>(
  function LeadFormForm({ action, className, children, onSubmit }, ref) {
    return (
      <form
        action={action}
        className={cn("w-full", className)}
        onSubmit={onSubmit}
        ref={ref}
      >
        {children}
      </form>
    );
  },
);
